import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import numeral from "numeral";

const Highcharts = window.Highcharts;
const HighchartsReact = window.HighchartsReact;

const breakdownOptions = (data, currentYear, selectedStateName, isOtherState) => {
  const mapValues = (path) => (_.get(data, path, 0));

  const MAX_BAR_WIDTH = 60;

  return {
    chart: {
      type: "bar",
      height: 350,
      width: 400,
    },
    credits: {
      enabled: false
    },
    title: {
      text: `CAPEX by Category, ${currentYear} - ${selectedStateName}${isOtherState ? ", Other States" : ""}`,
      style: {
        fontWeight: "bold"
      }
    },
    exporting: {
      enabled: false
    },
    legend: {
      backgroundColor: "#e5e3e3",
      padding: 20,
      margin: 10,
      width: "100%",
      itemMarginBottom: 4,
      itemMarginTop: 1,
      itemStyle: {
        fontWeight: "normal"
      },
      layout: "horizontal",
      symbolHeight: 14,
      symbolWidth: 14,
      symbolRadius: 0,
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: "normal"
      }
    },
    tooltip: {
      animation: true,
      backgroundColor: "transparent",
      borderWidth: 0,
      formatter: function() {
        return `
          <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
            <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
            <b>${selectedStateName}</b></br>
            ${this.series.name}
            </div>
            <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
              <div style="color: ${this.color}; font-weight: bold">
                ${this.series.tooltipOptions.valuePrefix}${numeral(this.point.y).format("0,0")}${this.series.tooltipOptions.valueSuffix}</b>
              </div>
            </div>
          </div>
        `;
      },
      hideDelay: 100,
      shadow: false,
      shape: "square",
      style: { color: "black", padding: 0 },
      useHTML: true,
      valuePrefix: "$",
      valueSuffix: "m"
    },
    xAxis: {
      labels: {
        enabled: false
      },
      lineWidth: 0,
      tickLength: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "$m"
      },
      gridLineWidth: 0,
      labels: {
        formatter: function() {
          return numeral(this.value).format("0,0");
        }
      },
      tickWidth: 1,
      tickLength: 5,
    },
    series: [
      {
        name: "Sludge management",
        data: [mapValues(["wastewater_capex", "sludge_management"])],
        color: "#7f8982",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Wastewater treatment plants",
        data: [mapValues(["wastewater_capex", "wastewater_treatment_plants"])],
        color: "#4fbded",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Wastewater networks",
        data: [mapValues(["wastewater_capex", "wastewater_networks"])],
        color: "#3282b9",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Seawater/brackish desalination",
        data: [mapValues(["water_capex", "seawater"])],
        color: "#ca3d3c",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Water treatment plants",
        data: [mapValues(["water_capex", "water_treatment_plants"])],
        color: "#f4b447",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Water networks",
        data: [mapValues(["water_capex", "water_networks"])],
        color: "#b9d263",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Water resources",
        data: [mapValues(["water_capex", "water_resources"])],
        color: "#54925b",
        maxPointWidth: MAX_BAR_WIDTH,
      },
    ],
  };
};

const CapexByCategory = ({ data, currentYear, selectedStateName, isOtherState }) => <HighchartsReact
  highcharts={Highcharts}
  constructorType={"chart"}
  options={breakdownOptions(data, currentYear, selectedStateName, isOtherState)}
/>;

CapexByCategory.propTypes = {
  data: PropTypes.shape({}).isRequired,
  currentYear: PropTypes.string.isRequired,
  selectedStateName: PropTypes.string.isRequired,
  isOtherState: PropTypes.bool.isRequired
};

export default CapexByCategory;
